import React from "react";
import { Mail, X } from "lucide-react";
import { Helmet } from 'react-helmet-async';


const Contact = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12 bg-[#0d0d1a] text-[#00F0FF]">
      <Helmet>
        <title>Contact Us | BrowserArena</title>
        <meta
          name="description"
          content="Get in touch with the BrowserArena team for support, feedback, or collaboration."
        />
      </Helmet>
      <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center border-b-2 border-[#FF007F] pb-2">
        📬 Contact Us
      </h1>

      <p className="text-center text-base sm:text-lg text-gray-300 mb-8">
        Have a question, feedback, or game suggestion? Reach out to us!
      </p>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-6 text-sm sm:text-base">
        {/* Email */}
        <a
          href="mailto:contact@browserarena.com"
          className="flex items-center gap-3 border border-[#00F0FF] px-5 py-3 rounded-md hover:border-[#FF007F] hover:text-[#FF007F] transition-colors"
        >
          <Mail className="w-5 h-5" />
          admin@browserarena.com
        </a>

        {/* X (Twitter) */}
        <a
          href="https://x.com/browserarena"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 border border-[#00F0FF] px-5 py-3 rounded-md hover:border-[#FF007F] hover:text-[#FF007F] transition-colors"
        >
          <X className="w-5 h-5" />
          @browserarena
        </a>
      </div>
    </div>
  );
};

export default Contact;
